module.exports = __webpack_public_path__ + "img/sepa.b28e0440.png";